import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CheckmarkGreenIcon, CloseIconToast } from "../../../assets/icons/icon";
import styles from "./styles.module.css";

/** Default options for `toast()` — use with SnackbarContext or direct `react-toastify` calls. */
export function mergeAppToastOptions(options = {}) {
  const merged = {
    position: "bottom-center",
    hideProgressBar: true,
    closeButton: false,
    ...options,
  };
  if (options.icon != null && options.icon !== "") {
    return merged;
  }
  const t = merged.type;
  if (t === "success") merged.icon = <CheckmarkGreenIcon />;
  else if (t === "error") merged.icon = <CloseIconToast />;
  return merged;
}

export const contextClass = {
  success: "newSecondaryColorBg",
  error: "newSecondaryColorBg",
  info: "newSecondaryColorBg",
  warning: "mustardYellowShadeBg",
  default: "newSecondaryColorBg",
};

export const getToastClassName = (context) =>
  `${contextClass[context?.type || "default"]} d-flex ${styles.customSnackbarWrapper}`;

/** Shared ToastContainer wrapper class (use on any ToastContainer that should match app toast styling). */
export const toastContainerClassName = styles.toastContainer;

const CustomSnackbar = () => {
  return (
    <div>
      <ToastContainer
        limit={1}
        autoClose={10000}
        className={toastContainerClassName}
        toastClassName={getToastClassName}
        position="bottom-center"
        closeButton={false}
        hideProgressBar
        pauseOnFocusLoss={false}
        style={{ zIndex: 10001 }}
      />
    </div>
  );
};

export default CustomSnackbar;
